<template>
  <div class="delegate-page">
    <van-nav-bar title="委托领证" left-arrow @click-left="onClickLeft" />

    <div class="notice-card">
      请确保委托人与被委托人信息真实有效，上传清晰正面人脸照片以完成身份材料留存。
    </div>

    <div v-if="delegateList.length > 0" class="delegate-list">
      <div class="delegate-card" v-for="item in delegateList" :key="item.id">
        <div class="card-title">{{ item.principalName }} → {{ item.agentName }}</div>
        <div class="card-meta">证件类型：{{ formatCertificateTypes(item.certificateTypes) }}</div>
        <div class="card-meta">创建时间：{{ item.createTime }}</div>
        <div class="card-actions">
          <van-button size="small" plain type="info" @click="downloadDelegatePdf(item)">下载 PDF</van-button>
          <van-button size="small" plain type="danger" @click="confirmDelete(item.id)">删除</van-button>
        </div>
      </div>
    </div>
    <van-empty v-else description="暂无委托领证记录" />

    <div class="bottom-bar">
      <van-button block type="info" @click="showAdd = true">新增委托</van-button>
    </div>

    <van-popup v-model="showAdd" position="bottom" round class="delegate-popup" @closed="resetForm">
      <div class="popup-head">
        <span>新增委托领证</span>
        <van-icon name="cross" @click="showAdd = false" />
      </div>

      <van-steps :active="activeStep" active-color="#2c5df6" class="delegate-steps">
        <van-step>基本信息</van-step>
        <van-step>证件类型</van-step>
        <van-step>人脸照片</van-step>
      </van-steps>

      <div class="popup-body">
        <template v-if="activeStep === 0">
          <div class="section-title">委托人信息</div>
          <van-field v-model="form.principalName" label="姓名" placeholder="请输入委托人姓名" required />
          <van-field v-model="form.principalIdCardNo" label="身份证号" placeholder="请输入18位身份证号" maxlength="18" required />

          <div class="section-title">被委托人信息</div>
          <van-field v-model="form.agentName" label="姓名" placeholder="请输入被委托人姓名" required />
          <van-field v-model="form.agentIdCardNo" label="身份证号" placeholder="请输入18位身份证号" maxlength="18" required />
        </template>

        <template v-if="activeStep === 1">
          <div class="section-title">请选择委托证件类型（可多选）</div>
          <van-checkbox-group v-model="form.certificateTypes">
            <van-cell-group>
              <van-cell v-for="item in certificateOptions" :key="item.value" clickable :title="item.label" @click="toggleCertificateType(item.value)">
                <template #right-icon>
                  <van-checkbox :name="item.value" ref="checkboxes" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </template>

        <template v-if="activeStep === 2">
          <div class="section-title">上传委托人人脸照片</div>
          <van-uploader v-model="faceFiles" multipart capture="camera" accept="image/*" :before-read="beforeReadFace" :after-read="afterReadFace" :max-count="1" upload-text="实时拍照" />
          <div class="upload-tip">请委托人本人实时拍摄清晰正面照，光线充足，无遮挡。照片将用于人脸识别。</div>
        </template>
      </div>

      <div class="popup-foot">
        <van-button v-if="activeStep > 0" plain @click="activeStep--">上一步</van-button>
        <van-button type="info" :loading="submitting" @click="handleNext">{{ activeStep === 2 ? '提交' : '下一步' }}</van-button>
      </div>
    </van-popup>



    <div class="pdf-render-box">
      <div class="studyTime" id="pdfDom">
        <div class="title">领证委托书</div>
        <div class="content1">
          <p>经本人同意，兹委托{{ currentDelegate.agentName }}{{ currentDelegate.agentIdCardNo }}到贵单位领取安全培训考核合格证书，请予以支持办理。</p>

          <p>行业类型（选项上打√）</p>
          <p>{{ getCertificateMark('危险化学品') }}危险化学品 {{ getCertificateMark('其他生产经营单位') }}其他生产经营单位</p>
          <p>{{ getCertificateMark('烟花爆竹') }}烟花爆竹 {{ getCertificateMark('非煤矿山') }}非煤矿山</p>
        </div>
        <div class="userinfo">
          <li><label>姓名：</label><span>{{ currentDelegate.principalName }}</span></li>
          <li><label>性别：</label><span>{{ formatSex(currentDelegate.principalSex) }}</span></li>
          <li><label>身份证号：</label><span>{{ currentDelegate.principalIdCardNo }}</span></li>
          <!-- <li><label>被委托人：</label><span>{{ currentDelegate.agentName }}</span></li>
          <li><label>被委托人身份证号：</label><span>{{ currentDelegate.agentIdCardNo }}</span></li> -->
        </div>
        <div class="face_img">
          <img v-if="currentDelegate.principalStudentPhoto" :src="getImageUrl(currentDelegate.principalStudentPhoto)" alt="" >
        </div>
        <div class="foot-info">
          <div></div>
          <div>委托时间：{{ formatPdfDate(currentDelegate.createTime) }}</div>
        </div>
        <div class="seal"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteCertificateDelegate, getCertificateDelegateList, saveCertificateDelegate } from '../../api/custom';
import { upload } from '../../api/upload';

export default {
  data() {
    return {
      activeStep: 0,
      delegateList: [],
      currentDelegate: {},
      faceFiles: [],
      htmlTitle: '领证委托书',
      form: {
        principalName: '',
        principalIdCardNo: '',
        agentName: '',
        agentIdCardNo: '',
        certificateTypes: [],
        facePhoto: ''
      },
      showAdd: false,
      submitting: false,
      certificateOptions: [
        { label: '危险化学品', value: '危险化学品' },
        { label: '其他生产经营单位', value: '其他生产经营单位' },
        { label: '烟花爆竹', value: '烟花爆竹' },
        { label: '非煤矿山', value: '非煤矿山' }
      ]
    };
  },
  created() {
    this.loadDelegateList();
  },
  methods: {
    loadDelegateList() {
      getCertificateDelegateList().then(res => {
        if (res.success) {
          this.delegateList = res.data.list || [];
        }
      });
    },
    onClickLeft() {
      this.$router.back();
    },
    formatCertificateTypes(value) {
      return value || '-';
    },
    getImageUrl(fileName) {
      if (!fileName) {
        return '';
      }
      return 'http://api.fzsyjxh.com/api/v1/getImage?name=' + fileName;
    },
    formatSex(value) {
      if (value === 1 || value === '1') {
        return '男';
      }
      if (value === 2 || value === '2') {
        return '女';
      }
      return '';
    },
    getCertificateMark(typeName) {
      const certificateTypes = this.currentDelegate.certificateTypes || '';
      return certificateTypes.indexOf(typeName) > -1 ? '☑' : '□';
    },
    formatPdfDate(value) {
      if (!value) {
        return '';
      }
      const dateText = String(value).split(' ')[0];
      const parts = dateText.split('-');
      if (parts.length < 3) {
        return dateText;
      }
      return parts[0] + '年' + parts[1] + '月' + parts[2] + '日';
    },
    downloadDelegatePdf(item) {
      this.currentDelegate = Object.assign({}, item);
      this.htmlTitle = '领证委托书-' + item.principalName + '-' + item.agentName;
      this.$nextTick(() => {
        this.getPdf('#pdfDom');
      });
    },
    toggleCertificateType(value) {
      const index = this.form.certificateTypes.indexOf(value);
      if (index > -1) {
        this.form.certificateTypes.splice(index, 1);
      } else {
        this.form.certificateTypes.push(value);
      }
    },
    validateBaseInfo() {
      const idCardReg = /^[0-9]{17}[0-9Xx]$/;
      if (!this.form.principalName || !this.form.principalIdCardNo || !this.form.agentName || !this.form.agentIdCardNo) {
        this.$toast('请填写完整委托人和被委托人信息');
        return false;
      }
      if (!idCardReg.test(this.form.principalIdCardNo) || !idCardReg.test(this.form.agentIdCardNo)) {
        this.$toast('请输入正确的18位身份证号');
        return false;
      }
      if (this.form.principalIdCardNo.toUpperCase() === this.form.agentIdCardNo.toUpperCase()) {
        this.$toast('委托人与被委托人不能为同一人');
        return false;
      }
      return true;
    },
    beforeReadFace(file) {
      const validateFile = item => {
        if (!item.type || !item.type.startsWith('image')) {
          this.$toast('请拍摄图片');
          return false;
        }
        if (item.size > 10485760) {
          this.$toast('图片超过10M');
          return false;
        }
        return true;
      };
      if (Array.isArray(file)) {
        return file.every(item => validateFile(item));
      }
      return validateFile(file);
    },
    handleNext() {
      if (this.activeStep === 0) {
        if (this.validateBaseInfo()) {
          this.activeStep = 1;
        }
        return;
      }
      if (this.activeStep === 1) {
        if (this.form.certificateTypes.length < 1) {
          this.$toast('请至少选择一种证件类型');
          return;
        }
        this.activeStep = 2;
        return;
      }
      this.submitDelegate();
    },
    afterReadFace(file) {
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        const resp = res.data;
        if (resp && resp.success) {
          this.form.facePhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success';
          this.$toast('上传成功');
        } else {
          this.faceFiles = [];
          this.$toast((resp && resp.message) || '上传失败');
        }
      }).catch(() => {
        this.faceFiles = [];
      });
    },
    submitDelegate() {
      if (!this.form.facePhoto) {
        this.$toast('请上传委托人人脸照片');
        return;
      }
      this.submitting = true;
      saveCertificateDelegate(this.form).then(res => {
        this.submitting = false;
        if (res.success) {
          this.$toast.success(res.message || '提交成功');
          this.showAdd = false;
          this.loadDelegateList();
        } else {
          this.$dialog.alert({ message: res.message, theme: 'round-button', confirmButtonText: '确定' });
        }
      }).catch(() => {
        this.submitting = false;
      });
    },
    confirmDelete(id) {
      this.$dialog.confirm({ message: '删除后该委托记录将无法恢复，请确认是否继续？' }).then(() => {
        deleteCertificateDelegate(id).then(res => {
          if (res.success) {
            this.$toast.success('删除成功');
            this.loadDelegateList();
          }
        });
      }).catch(() => {});
    },
    resetForm() {
      this.activeStep = 0;
      this.faceFiles = [];
      this.submitting = false;
      this.form = {
        principalName: '',
        principalIdCardNo: '',
        agentName: '',
        agentIdCardNo: '',
        certificateTypes: [],
        facePhoto: ''
      };
    }
  }
};
</script>

<style lang="less">
.seal{
  width: 100px;
  height: 100px;
  position: absolute;
  right: 80px;
  bottom: 40px;
  background: url(../../asset/images/redmiwork.png) no-repeat ;
  background-size: contain;
}
.pdf-render-box {
  position: fixed;
  left: -10000px;
  top: 0;
  z-index: -1;
}
.studyTime{
  width: 512px;
  height: 772px;
  /*height: 600px;*/
  background: url(../../asset/images/bag1.jpg) no-repeat ;
  background-size: contain;
  padding: 55px 55px 20px;
  position: relative;
  box-sizing: border-box;

}
.studyTime .face_img{
  position: absolute;
  right: 56px;
  bottom: 179px;
  /*width: 120px;*/
  font-size: 12px;
}
.studyTime .face_img img{
  height: 120px;
}
.studyTime .face_img p{
  width: 100%;
  text-align: center;
  line-height: 18px;
  color: #000000;
  font-size: 12px;
  font-weight: bold;
}
.studyTime .foot-info{
  position: absolute;
  bottom: 48px;
  display: flex;
  justify-content: space-between;
  width: 80%;
  font-size: 12px;
  font-weight: bold;
  color: #000000;
}
.studyTime .title{
  font-size: 18px;
  color: #1e1e1e;
  font-weight: bold;
  text-align: center;

}
.studyTime .content1{
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  position: static;
  line-height: 24px;
}
.studyTime li{
  list-style: none;
}
.studyContent{
  font-weight: normal;
  display: flex;
  /*justify-content: space-between;*/
  flex-direction: column;

}
.studyContent li{
  list-style: none;
  width: 100%;
  display: flex;
  line-height: 25px;
  border: 1px solid #000;
}
.studyContent li span:first-child{
  width: 8%;
  border-right: 1px solid #000;
  text-align: center;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.studyContent li span:nth-child(2){
  width: 77%;
  border-right: 1px solid #000;
  padding-left: 4px;
  text-align: left;
}
.studyContent li span:last-child{
  width: 20%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}


.studyContent li:nth-child(n+2){
  border-top: none;
}
.studyTime .userinfo{
  position: absolute;
  left: 63px;
  bottom: 179px;
  color: #000000;
}
.studyTime .userinfo li{
  font-weight: bold;
  color: #000000;
  line-height: 28px;
  font-size: 14px;
}
.delegate-page {
  min-height: 100vh;
  background: #f5f6f8;
  padding-bottom: 72px;

  .notice-card {
    margin: 12px 16px;
    padding: 10px 12px;
    color: #2c5df6;
    font-size: 12px;
    line-height: 1.6;
    background: #eef3ff;
    border-radius: 8px;
  }

  .delegate-list {
    padding: 0 16px;
  }

  .delegate-card {
    margin-bottom: 10px;
    padding: 14px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, .06);
  }

  .card-title {
    margin-bottom: 8px;
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 500;
  }

  .card-meta {
    color: #999;
    font-size: 12px;
    line-height: 1.8;
  }

  .card-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f0f0f0;
  }

  .bottom-bar {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px 16px 24px;
    background: #fff;
    border-top: 1px solid #ebebeb;
  }
}

.delegate-popup {
  max-height: 90vh;

  .popup-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    color: #1a1a1a;
    font-size: 15px;
    font-weight: 600;
    border-bottom: 1px solid #ebebeb;
  }

  .delegate-steps {
    padding: 14px 8px 6px;
  }

  .popup-body {
    min-height: 300px;
    max-height: 52vh;
    overflow-y: auto;
    padding: 0 16px 16px;
  }

  .section-title {
    margin: 16px 0 8px;
    color: #888;
    font-size: 12px;
    font-weight: 500;
  }

  .upload-tip {
    margin-top: 10px;
    padding: 10px 12px;
    color: #999;
    font-size: 12px;
    line-height: 1.7;
    background: #f7f8fa;
    border-radius: 8px;
  }

  .popup-foot {
    display: flex;
    gap: 10px;
    padding: 12px 16px 28px;
    border-top: 1px solid #ebebeb;

    .van-button {
      flex: 1;
    }
  }
}
</style>
